import {Injectable} from '@angular/core';
import {Observable, zip, ObservableInput, of} from 'rxjs';
import {map} from 'rxjs/operators';
import {LocationManager} from '../../data/manager/location/location.manager';
import {DeliveryTypeEnum} from '../../data/networking/models/location/enum/delivery-type.enum';
import {AddressManager} from '../../data/manager/customer/address/address.manager';
import {LocalStorageManager} from '../../data/manager/local-storage/local-storage.manager';
import {SessionStorageManager} from '../../data/manager/session-storage/session-storage.manager';
import {ConfigurationManager} from '../../data/manager/configuration/configuration.manager';
import { OpenStreetMapSearchResponse } from 'src/app/data/networking/models/address/responses/open-street-map';

@Injectable({
  providedIn: 'root',
})
export class AddressFormVm {
  constructor(private locationManager: LocationManager,
              private addressManager: AddressManager,
              private lsm: LocalStorageManager,
              private configurationManager: ConfigurationManager,
              private ssm: SessionStorageManager) { }

  autocomplete(data): Observable<any> {
    return this.locationManager.autocomplete(data);
  }

  getCities(): Observable<any> {
    const confGeneral = this.configurationManager.getConfigurationModule('general');
    const packages: ObservableInput<any>[] = [this.locationManager.getCities(DeliveryTypeEnum.EXPRESS)];
    if (confGeneral.national) { packages.push(this.locationManager.getCities(DeliveryTypeEnum.NATIONAL)); }
    if (confGeneral.envialoya) { packages.push(this.locationManager.getCities(DeliveryTypeEnum.ENVIALOYA)); }
    return zip(...packages);
  }

  getLocalCities(){
    const confGeneral = this.configurationManager.getConfigurationModule('general');
    const packages = [this.locationManager.getLocalCities(DeliveryTypeEnum.EXPRESS)];
    if (confGeneral.national) { packages.push(this.locationManager.getLocalCities(DeliveryTypeEnum.NATIONAL)); }
    if (confGeneral.envialoya) { packages.push(this.locationManager.getLocalCities(DeliveryTypeEnum.ENVIALOYA)); }
    return zip(...packages);
  }

  getDeliveryTypeText(): Observable<any> {
    return this.locationManager.getDeliveryTypeText().pipe(map(r => r.deliveryTimeLabelGeneric));
  }

  create(adress){
    return ( typeof this.addressManager.create(adress) === undefined ) 
              ? of( this.addressManager.create(adress) ) 
              : this.addressManager.create(adress)
  }

  update(adress){
    return this.addressManager.update(adress);
  }

  createAddress(data, coordinates?): Observable<any> {
   return this.addressManager.handleAddressData(data, 'create', coordinates);
  }

  updateAddress(data, coordinates?): Observable<any> {
    return this.addressManager.handleAddressData(data, 'update', coordinates);
  }

  getLocation() {
    return this.locationManager.getLocation();
  }

  getAddress(): Observable<any> {
    return this.addressManager.get();
  }

  validateAddress(data, isInsideGeomalla?): Observable<any> {
    return this.addressManager.validate(data, isInsideGeomalla);
  }

  getCityById(cityId): Observable<any> {
    return this.locationManager.getCityById(cityId);
  }

  getEnvialoYaCityByName(cityName): Observable<any> {
    return this.locationManager.getEnvialoYaCityByName(cityName);
  }

  getAddresDefault() {
    return this.addressManager.getDeliveryAddress();
  }

  getTitleDelivery() {
    return this.ssm.get('deliveryTypeText');
  }

  transformCoordinate(coordinates) {
    return this.locationManager.transformCoordinate(coordinates);
  }

  getCurrentPosition() {
    return this.locationManager.getCurrentPosition();
  }

  verifyPoint({latitude, longitude}, polygon) {
    return this.addressManager.verifyPoint(latitude, longitude, polygon);
  }

  openStreetMapSearch(query: string): Observable<OpenStreetMapSearchResponse> {
    return this.addressManager.openStreetMapSearch(query);
  }

}
